module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layer"
  }, [(_vm.placement === 'fill-area') ? [_c('img', {
    staticClass: "center-image",
    style: (_vm.style),
    attrs: {
      "src": _vm.image
    }
  })] : _vm._e(), (_vm.placement === 'offset-from-center') ? [_c('img', {
    staticClass: "offset-image",
    style: (_vm.style),
    attrs: {
      "src": _vm.image,
      "width": _vm.imageWidth
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de7216a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSEffect.vue
// module id = 287
// module chunks = 15